<template>
	<div>
		<img :src="'static/assets/img/payments/papara.png'" />
		<template v-if="$route.params.withdraw == 'pay'">
			<paparaForm />
			<br />
			<h4 class="mt-2">Güncel Papara hesaplarımızı lütfen Canlı Destek üzerinden isteyiniz.</h4>
		</template>
		<template v-if="$route.params.withdraw == 'withdraw'">
			<paparaWithdraw />
		</template>
	</div>
</template>

<script>
	import paparaForm from '@/components/payments/form/papara'
	import paparaWithdraw from '@/components/payments/form/paparaWithdraw'
    export default {
        name: "papara",
        components: {paparaWithdraw,paparaForm}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/papara.vue